import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/blog/[...slug]/ArticlePage.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/layout/template.tsx")